import React, { useContext, useEffect, useState } from 'react';
import Search from '../../../../../../Assets/Modals/SearchIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setEditSection, setVideo } from '../../../../../../Features/lensSlice';
import TabButton from '../../../../../../Components/TabButton/TabButton';
import { VideoContext } from '../../../../../../Context/VideoContext';
import Audio from './Audio';
import SavedAudio from './SavedAudio';

import { fetchFile } from '@ffmpeg/util';
import { FFmpeg } from '@ffmpeg/ffmpeg';

import { showToast } from '../../../../../../Components/Toaster/Toaster';

//Store the ffmpeg instance
let ffmpeg;

function AudioEdit() {
    const dispatch = useDispatch();

    const video = useSelector((state) => state.lens.media.video);

    const [duration, setDuration] = useState(0);
    const [audioType, setAudioType] = useState('browse');
    const [inputValue, setInputValue] = useState('');
    const [localSelectedAudio, setLocalSelectedAudio] = useState({});
    const [list, setList] = useState([]);
    const [savedList, setSavedList] = useState([]);

    const {
        setVideoFile,
        musicList,
        setSelectedAudio,
        videoFile,
        setOriginalAudioUrl,
        setLoading,
        savedMusicList
    } = useContext(VideoContext);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    }

    const handleKeyDown = (e) => {
        if(e.key === 'Enter') {
            if(audioType === 'browse') {
                const filteredList = musicList.filter(item => item.name.toLowerCase().includes(inputValue.toLowerCase()));
                setList(filteredList);
            }
            else {
                const filteredList = savedMusicList.filter(item => item.songName.toLowerCase().includes(inputValue.toLowerCase()));
                setSavedList(filteredList);
            }
        }
    }

    useEffect(() => {
        setInputValue('');
        if(audioType === 'browse') {
            setList(musicList);
        }
        else {
            setSavedList(savedMusicList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioType]);

    useEffect(() => {
        setSavedList(savedMusicList);
    }, [savedMusicList]);

    const handleCancel = () => {
        // setSelectedAudio({});
        dispatch(setEditSection(null));
    }

    const updateAudioType = (selection) => {
        setAudioType(selection);
    }

    useEffect(() => {
        setList(musicList);
    }, [musicList]);

    // Merge music with video

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const handleConfirmAudio = async () => {
        setLoading(true);

        if (isScriptLoaded) {
            if(!localSelectedAudio || !videoFile) {
                showToast('Both audio and video are required.', 'warning');
                return;
            }

            let recordedUrl;
            const musicUrl = `https://audius-discovery-12.cultur3stake.com/v1/tracks/${localSelectedAudio.trackId}/stream?app_name=hyprcom`

            try {
                // First fetch the audio and create a url using blob
                const response = await fetch(musicUrl);
                const blob = await response.blob();
                recordedUrl = URL.createObjectURL(blob);
            }
            catch (error) {
                console.error('Error fetching audio:', error);
                return;
            }

            const audioData = await fetch(recordedUrl).then(r => r.blob());
            const videoData = await fetchFile(videoFile);

            await ffmpeg.writeFile('audio.mp3', await fetchFile(audioData));
            await ffmpeg.writeFile('video.mp4', videoData);

            // Extract existing audio from the video
            const extractedAudio = await ffmpeg.exec(['-i', 'video.mp4', '-q:a', '0', '-map', 'a', 'extracted_audio.mp3']);

            // Save the extracted audio
            if(!Boolean(extractedAudio)) {
                const extractedAudioData = await ffmpeg.readFile('extracted_audio.mp3');
                const extractedAudioBlob = new Blob([extractedAudioData.buffer], { type: 'audio/mp3' });
                const extractedAudioUrl = URL.createObjectURL(extractedAudioBlob);
                setOriginalAudioUrl(extractedAudioUrl);
            }

            // Remove existing audio from the video
            await ffmpeg.exec(['-i', 'video.mp4', '-c:v', 'copy', '-an', 'video_no_audio.mp4']);

            // Merge the new audio with the video without existing audio
            await ffmpeg.exec(['-i', 'video_no_audio.mp4', '-i', 'audio.mp3', '-t', `${duration}`, '-c:v', 'copy', '-c:a', 'aac', '-strict', 'experimental', 'output.mp4'])
            .then(() => {
                // setLoading(false);
            })
            .catch((error) => {
                console.error('Promise rejected:', error);
                setLoading(false);
            });

            let data;
            try {
                data = await ffmpeg.readFile('output.mp4');
            }
            catch(err) {
                console.log(err);
            }

            const mergedBlob = new Blob([data.buffer], { type: 'video/mp4' });
            const url = URL.createObjectURL(mergedBlob);

            // Create File from blob
            const fileName = 'output.mp4';
            const mergedFile = new File([mergedBlob], fileName, { type: 'video/mp4' });

            setVideoFile(mergedFile);
            dispatch(setVideo({
                id: video.id,
                url: url,
            }));
            setSelectedAudio(localSelectedAudio);

            dispatch(setEditSection(null));

            setLoading(false);
            showToast('Music added to video!', 'success');
        }
    }

    useEffect(() => {
        const loadffmpeg = async () => {
            ffmpeg = new FFmpeg();
            await ffmpeg.load({ log: true });
            setIsScriptLoaded(true);
        }

        loadffmpeg();
    }, []);

    const setAudio = (audio) => {
        setLocalSelectedAudio(audio);
    }

    // Get Video Current Duration
    useEffect(() => {
        if (video.url) {
            const videoElement = document.createElement('video');
            videoElement.src = video.url;
      
            const handleLoadedMetadata = () => {
                setDuration(videoElement.duration.toFixed(2));
            };
      
            videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
      
            return () => {
                videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            };
        }
    }, [video]);

    return (
        <div className='flex flex-col size-full p-4 bg-[#FFFFFF] z-10'>
            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <h1 className='font-medium text-[16px] leading-5 text-[#121212]'>Audio</h1>

                    <button 
                        onClick={handleCancel} 
                        className='underline font-medium text-[14px] leading-5 text-[#1055EB]'
                    >Cancel</button>
                </div>

                <div className="rounded-lg bg-[#F5F5F5] p-4 flex items-center gap-1 border border-[#EAEAEA]">
                    <div className="size-6 flex items-center justify-center">
                        <img src={Search} alt="" />
                    </div>
    
                    <input 
                        value={inputValue} 
                        onChange={handleChange} 
                        onKeyDown={handleKeyDown}
                        placeholder='Search audio' 
                        className='outline-none bg-transparent w-[calc(100%-24px)] font-medium text-base text-[#121212] placeholder:text-[#666666]' 
                        type="text" 
                    />
                </div>
            </div>

            <div className="grid grid-cols-2">
                <TabButton 
                    id='browse' 
                    optionName='Browse' 
                    selected={audioType} 
                    handleSelect={updateAudioType} 
                />
                <TabButton 
                    id='saved' 
                    optionName='Saved' 
                    selected={audioType} 
                    handleSelect={updateAudioType} 
                />
            </div>

            <div className="flex flex-col max-h-1/2 overflow-y-scroll no-scrollbar mt-1 pb-[190px]">
                {
                    audioType === 'browse' ? 
                    <>
                        {list.map(audio => {
                            return (
                                <Audio 
                                    key={audio.trackId} 
                                    audio={audio} 
                                    musicUrl={`https://audius-discovery-12.cultur3stake.com/v1/tracks/${audio.trackId}/stream?app_name=hyprcom`}
                                    selected={localSelectedAudio} 
                                    handleLocalAudioSelect={(audio) => setAudio(audio)} 
                                />
                            );
                        })}
                    </> : 
                    <>
                        {savedList.map(audio => {
                            return (
                                <SavedAudio 
                                    key={audio.id} 
                                    audio={audio} 
                                    musicUrl={`https://audius-discovery-12.cultur3stake.com/v1/tracks/${audio.trackId}/stream?app_name=hyprcom`}
                                    selected={localSelectedAudio} 
                                    handleLocalAudioSelect={(audio) => setAudio(audio)} 
                                />
                            );
                        })}
                    </>
                }
            </div>

            {
                Object.keys(localSelectedAudio).length > 0 && 
                <div className="absolute bottom-0 left-0 w-full px-4 py-3 bg-[#FFFFFF] border-t border-[#EAEAEA]">
                    <button onClick={handleConfirmAudio} className='w-full px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[14px] leading-[26px] text-buttonText'>Confirm Audio</button>
                </div>
            }
        </div>
    )
}

export default AudioEdit;
